let rhCurrentMenu = 'main';

(function ($) {
    $( document ).ready(function() {
        $('.rh-nav-open--desktop').on( "mouseenter", function() {
            $('.rh-nav').attr('data-menu-type', 'desktop');
            $('.main-nav__all').addClass('active-menu');
            $('.rh-nav').removeClass('rh-nav--hidden');
            $('.rh-nav__menu[data-menu="main"]').removeClass('rh-nav__menu--hidden-desktop');
        } );

        $('.rh-nav-open--desktop').on( "mouseleave", function(e) {
            if( !$(e.relatedTarget).hasClass('rh-nav__menu') && !$(e.relatedTarget).hasClass('rh-nav') &&  !$(e.relatedTarget).hasClass('rh-nav__link')) {
                closeMenu();
            }
        } );


        $('.rh-nav-open--mobile').on( "click", function() {
            $('.rh-nav').attr('data-menu-type', 'mobile');
            $('.rh-nav').removeClass('rh-nav--hidden');
            $('.rh-nav__menu[data-menu="main"]').removeClass('rh-nav__menu--next');
            $('.rh-nav__menu[data-menu="main"]').addClass('rh-nav__menu--inview');
        } );

        $('.rh-nav__back').on( "click", function(e) {
            let rhPrevMenu = $('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').data('prev-menu');
            $('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').addClass('rh-nav__menu--next');
            $('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').removeClass('rh-nav__menu--inview');
            $('.rh-nav__menu[data-menu="'+rhPrevMenu+'"]').addClass('rh-nav__menu--inview');
            $('.rh-nav__menu[data-menu="'+rhPrevMenu+'"]').removeClass('rh-nav__menu--prev');
            $('.rh-nav__menu-title').text($('.rh-nav__menu[data-menu="'+rhPrevMenu+'"]').data('title'));
            rhCurrentMenu = rhPrevMenu;
            if (rhPrevMenu == 'main') {
                $('.rh-nav__back').addClass('rh-nav__back--hidden');
            }
        } );

        $(document).on( "mouseleave", '.rh-nav[data-menu-type="desktop"] .rh-nav__inner', function(e) {
            closeMenu();
        } );


        $('.rh-nav__close').on( "click", function() {
            closeMenu();
        } );

        let hoverTimeout;
        let timeoutAmount;

        $('.rh-nav__link').on( "mouseenter", function() {
            if (window.matchMedia("(pointer: coarse)").matches) {
                timeoutAmount = 0;
            } else {
                timeoutAmount = 400;
            }

            var $this = $(this);
            var submenu = $this.data('submenu');
            var currentlevel = $this.data('level');

            clearTimeout(hoverTimeout);

            hoverTimeout = setTimeout(function() {
                $('.rh-nav__link[data-level="'+currentlevel+'"]').removeClass('rh-nav__link--active');
                $this.addClass('rh-nav__link--active');

                $('.rh-nav__menu').each(function () {
                    let level = parseInt($(this).data('level'), 10);
                    if (level >= currentlevel) {
                        $(this).addClass('rh-nav__menu--hidden-desktop');
                        $(this).find('.rh-nav__link').removeClass('rh-nav__link--active');
                    }
                });
                $('.rh-nav__menu[data-menu="'+submenu+'"]').removeClass('rh-nav__menu--hidden-desktop');
            }, timeoutAmount);
        } );

        $('.rh-nav__link').on('mouseleave', function() {
            clearTimeout(hoverTimeout);
        });

        $('div.rh-nav__link').on( "click", function() {
            rhCurrentMenu = $(this).data('submenu');
            let rhPrevMenu = $(this).parent().data('menu');
            $(this).parent().addClass('rh-nav__menu--prev');
            $(this).parent().removeClass('rh-nav__menu--inview');
            $('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').attr('data-prev-menu', rhPrevMenu)
            $('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').addClass('rh-nav__menu--inview');
            $('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').removeClass('rh-nav__menu--next');
            $('.rh-nav__back').removeClass('rh-nav__back--hidden');
            $('.rh-nav__menu-title').text($('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').data('title'));
        } );

        $('.main-nav a').on( "mouseenter", function() {
            $('.main-nav__item').removeClass('active-menu');
            $('.main-nav__special-item').removeClass('active-menu');
            if($(this).data('menu-sub')){
                $(this).addClass('active-menu');
            }

            if(!$(this).data('disable-sub')) {
                toggleMenu(this);
            } else {
                closeSubMenu();
            }
        } );

        $('.nav-wrapper, .sub-nav__inner').on( "mouseleave", function() {
            closeSubMenu();
        } );
    });
})(jQuery);

function closeMenu(){
    rhCurrentMenu = 'main';
    $('.main-nav__all').removeClass('active-menu');
    $('.rh-nav').addClass('rh-nav--hidden');
    $('.rh-nav__menu').addClass('rh-nav__menu--hidden-desktop');
    $('.rh-nav__menu').addClass('rh-nav__menu--next');
    $('.rh-nav__menu').removeClass('rh-nav__menu--inview rh-nav__menu--prev');
    $('.rh-nav__back').addClass('rh-nav__back--hidden');
    $('.rh-nav__menu-title').text($('.rh-nav__menu[data-menu="'+rhCurrentMenu+'"]').data('title'));
    $('.rh-nav__link').removeClass('rh-nav__link--active');
}

function toggleMenu(element){
    $( '.sub-nav__sub-wrapper' ).addClass( "hidden-menu" );
    let submenu = $(element).data('menu-sub');
    $('.sub-nav').removeClass("hidden-menu");
    $('.sub-nav__inner [data-menu="' + submenu + '"]').removeClass("hidden-menu");
}

function closeSubMenu(){
    $( '.sub-nav, .sub-nav__main, .sub-nav__sub-wrapper' ).addClass( "hidden-menu" );
    $('.main-nav__item').removeClass('active-menu');
    $('.main-nav__special-item').removeClass('active-menu');
    $('.sub-nav__main-item').removeClass('active-menu');
    $('.sub-nav__inner').removeClass('justify-content-end');
}
